export { default } from './MapCreateSpotLocation';
